import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-ajuda',
  templateUrl: './modal-ajuda.component.html',
  styleUrls: ['./modal-ajuda.component.scss']
})
export class ModalAjudaComponent implements OnInit {
  texto: string;
  itens: any;

  constructor() {}

  ngOnInit() {}
}
